"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalSheetCreateOrEditGroupDialog = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_intl_1 = require("react-intl");
var formik_1 = require("formik");
var formik_material_ui_1 = require("formik-material-ui");
var AutocompleteField_1 = require("../../../components/autocomplete/AutocompleteField");
var utils_1 = require("../../../utils");
var useResetStyles_1 = require("../../../hooks/useResetStyles");
var useYup_1 = require("../../../hooks/useYup");
var ApprovalSheetManagementContext_1 = require("../../../context/ApprovalSheetManagementContext");
var context_1 = require("../../../context");
var components_1 = require("../../../components");
var styles_1 = require("@material-ui/core/styles");
var groupTypeOptions = ['REVIEWER', 'APPROVER'];
var addGroupSchemaDefaultValues = {
    groupTitle: '',
    groupType: '',
    participantsOrder: 'parallel',
    participants: [],
};
var getGroupTypeOptionLabelCreator = function (intl) {
    return function (option) {
        return option ? intl.formatMessage({ id: "groupType." + option }) : '';
    };
};
var getGroupTypeOptionSelected = function (option, value) {
    return option === value;
};
exports.ApprovalSheetCreateOrEditGroupDialog = function () {
    var getAllUsers = react_1.useContext(context_1.ApprovalSheetContext).getAllUsers;
    var _a = react_1.useContext(ApprovalSheetManagementContext_1.ApprovalSheetManagementContext), editGroup = _a.editGroup, isAddGroupModalOpen = _a.isAddGroupModalOpen, setIsAddGroupModalOpenFalse = _a.setIsAddGroupModalOpenFalse, groupsUpdated = _a.groupsUpdated, setGroupsUpdated = _a.setGroupsUpdated, setEditGroup = _a.setEditGroup;
    var Yup = useYup_1.useYup().Yup;
    var _b = react_1.useState(function () { return Promise.resolve(); }), onConfirmAction = _b[0], setOnConfirmAction = _b[1];
    var _c = react_1.useState(''), confirmFio = _c[0], setConfirmFio = _c[1];
    var resetOnConfirmAction = function () { return setOnConfirmAction(function () { return Promise.resolve(); }); };
    var resetConfirmButtonText = function () { return setConfirmFio(''); };
    var onConfirmDialogCancel = function () {
        resetConfirmButtonText();
        resetOnConfirmAction();
    };
    var initialValues = react_1.useMemo(function () {
        if (!editGroup) {
            return addGroupSchemaDefaultValues;
        }
        else {
            var groupType = editGroup.groupType, groupTitle = editGroup.groupTitle, parallel = editGroup.parallel, participants = editGroup.participants;
            return {
                groupTitle: groupTitle,
                groupType: groupType,
                participantsOrder: parallel ? 'parallel' : 'consecutive',
                participants: utils_1.mapParticipantsDTOToIdTitle(participants),
            };
        }
    }, [editGroup]);
    var addGroupSchema = Yup.object().shape({
        groupTitle: Yup.string().required(),
        groupType: Yup.string().required(),
        participantsOrder: Yup.string().required(),
        participants: Yup.array().required().min(1),
    });
    var _d = react_1.useState([]), userOptions = _d[0], setUserOptions = _d[1];
    react_1.useEffect(function () {
        var loadUsers = function () { return __awaiter(void 0, void 0, void 0, function () {
            var users;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAllUsers()];
                    case 1:
                        users = _a.sent();
                        setUserOptions(users);
                        return [2 /*return*/];
                }
            });
        }); };
        loadUsers();
    }, []);
    var closeDialog = function () {
        setIsAddGroupModalOpenFalse();
        setEditGroup(null);
    };
    var onSubmit = function (values, _a) {
        var resetForm = _a.resetForm;
        onCreateOrEditGroup(values);
        resetForm();
        closeDialog();
    };
    var onCreateOrEditGroup = function (newGroup) {
        var participantsOrder = newGroup.participantsOrder, participants = newGroup.participants, restNewGroup = __rest(newGroup, ["participantsOrder", "participants"]);
        var parallel = participantsOrder === 'parallel';
        var participantsDTO = utils_1.mapIdTitleToParticipantsDTO(participants, parallel, editGroup === null || editGroup === void 0 ? void 0 : editGroup.participants);
        var groupIndex = (editGroup === null || editGroup === void 0 ? void 0 : editGroup.index) || groupsUpdated.length + 1;
        var newGroupsUpdated = __spreadArrays(groupsUpdated);
        newGroupsUpdated.splice(groupIndex - 1, 1, __assign(__assign({}, restNewGroup), { id: editGroup === null || editGroup === void 0 ? void 0 : editGroup.id, parallel: parallel, index: groupIndex, participants: participantsDTO, isActiveGroup: (editGroup === null || editGroup === void 0 ? void 0 : editGroup.isActiveGroup) || false, isAfterActiveGroup: true }));
        setGroupsUpdated(newGroupsUpdated);
    };
    var intl = react_intl_1.useIntl();
    var getGroupTypeOptionLabel = react_1.useMemo(function () { return getGroupTypeOptionLabelCreator(intl); }, [intl]);
    var isEditGroup = react_1.useMemo(function () {
        return !!(editGroup === null || editGroup === void 0 ? void 0 : editGroup.id);
    }, [editGroup]);
    var theme = styles_1.useTheme();
    var chipIconSize = theme.variables.palette.approval.management.chipIconSize;
    var renderParticipantsTags = function (value, getTagProps) {
        var getCustomizedTagProps = function (params) {
            var index = params.index;
            var _a = value[index], userId = _a.id, fio = _a.title;
            var _b = utils_1.getResolutionAndFlag(userId, editGroup), resolution = _b[0], hasResolution = _b[1];
            var tagProps = getTagProps(params);
            var _c = tagProps, onDelete = _c.onDelete, restTagProps = __rest(_c, ["onDelete"]);
            var onConfirmDeleteAction = function () {
                return Promise.resolve().then(onDelete).finally(onConfirmDialogCancel);
            };
            var onDeleteTag = function () {
                setOnConfirmAction(function () { return onConfirmDeleteAction; });
                setConfirmFio(fio);
            };
            return __assign(__assign({ className: 'MuiChip-label MuiChip-labelSmall', disabled: false }, restTagProps), { onDelete: hasResolution ? onDeleteTag : onDelete });
        };
        return value.map(function (option, index) {
            var userId = option.id;
            var _a = utils_1.getResolutionAndFlag(userId, editGroup), resolution = _a[0], hasResolution = _a[1];
            var withTooltip = function (children) {
                return hasResolution ? (react_1.default.createElement(core_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "participantWithResolutionTooltip" }) }, children)) : (children);
            };
            return withTooltip(react_1.default.createElement(core_1.Chip, __assign({ label: components_1.getOptionLabelDefault(option), size: "small" }, getCustomizedTagProps({ index: index }), (hasResolution && {
                icon: (react_1.default.createElement(components_1.Resolution, { resolution: resolution, hasResolution: hasResolution, size: chipIconSize, styles: { paddingLeft: '8px', marginRight: '-4px', marginTop: '-1px' } })),
            }))));
        });
    };
    var resetClasses = useResetStyles_1.useResetStyles();
    return (react_1.default.createElement(core_1.Dialog, { fullWidth: true, maxWidth: "xs", "aria-labelledby": "add-group-dialog-title", open: isAddGroupModalOpen },
        react_1.default.createElement(core_1.DialogTitle, { id: "add-group-dialog-title" }, isEditGroup ? (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "editGroupDialogTitle" })) : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: "addGroupDialogTitle" }))),
        react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, validationSchema: addGroupSchema, onSubmit: onSubmit },
            react_1.default.createElement(formik_1.Form, null,
                react_1.default.createElement(core_1.DialogContent, null,
                    react_1.default.createElement(core_1.Grid, { container: true, spacing: 4, direction: "column", justify: "center" },
                        react_1.default.createElement(core_1.Grid, { item: true },
                            react_1.default.createElement(formik_1.Field, { name: "groupTitle", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "groupTitleLabel" }), fullWidth: true, component: formik_material_ui_1.TextField, variant: "outlined", color: "primary", multiline: true, size: "small" })),
                        react_1.default.createElement(core_1.Grid, { item: true },
                            react_1.default.createElement(AutocompleteField_1.AutocompleteField, { fieldName: "groupType", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "groupTypeLabel" }), options: groupTypeOptions, disableClearable: true, getOptionLabel: getGroupTypeOptionLabel, getOptionSelected: getGroupTypeOptionSelected })),
                        react_1.default.createElement(core_1.Grid, { item: true },
                            react_1.default.createElement(core_1.FormControl, { component: "fieldset" },
                                react_1.default.createElement(core_1.FormLabel, { component: "legend", className: resetClasses.resetCss },
                                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "participantsOrderLabel" })),
                                react_1.default.createElement(formik_1.Field, { component: formik_material_ui_1.RadioGroup, name: "participantsOrder", row: true },
                                    react_1.default.createElement(core_1.FormControlLabel, { name: "participantsOrder", value: "parallel", control: react_1.default.createElement(core_1.Radio, { color: "primary" }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "participantsOrderParallel" }) }),
                                    react_1.default.createElement(core_1.FormControlLabel, { name: "participantsOrder", value: "consecutive", control: react_1.default.createElement(core_1.Radio, { color: "primary" }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "participantsOrderConsecutive" }) })))),
                        react_1.default.createElement(core_1.Grid, { item: true },
                            react_1.default.createElement(components_1.AutocompleteFieldVirtualized, { fieldName: "participants", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "participantsLabel" }), options: userOptions, multiple: true, renderTags: renderParticipantsTags })))),
                react_1.default.createElement(core_1.DialogActions, null,
                    react_1.default.createElement(core_1.Button, { color: "primary", variant: "contained", type: "submit" },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "saveButton" })),
                    react_1.default.createElement(core_1.Button, { autoFocus: true, color: "primary", onClick: closeDialog },
                        react_1.default.createElement(react_intl_1.FormattedMessage, { id: "cancelButton" }))))),
        react_1.default.createElement(components_1.ConfirmationDialog, { id: "confirm-delete-participant-with-resolution", open: !!confirmFio, onConfirm: onConfirmAction, onCancel: onConfirmDialogCancel, title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "confirmDeleteParticipantWithResolutionTitle" }), message: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "confirmDeleteParticipantWithResolutionText", values: { fio: confirmFio } }), confirmButtonText: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "deleteButton" }) })));
};
